import { useChatStore } from '../state/chatStore'
import { STRINGS, type UiLocale, type UiStrings } from './i18n-strings'

export { STRINGS, strings } from './i18n-strings'
export type { UiLocale, UiStrings } from './i18n-strings'

/** Die Texte in der Sprache des Besuchers — aus dem Store, reagiert auf Wechsel. */
export function useT(): UiStrings {
  const locale = useChatStore((s) => s.locale)
  return STRINGS[locale]
}

/** Die Sprache des Browsers als Startwert: Englisch, wenn das Gerät Englisch spricht, sonst Deutsch. */
export function browserLocale(): UiLocale {
  try {
    return typeof navigator !== 'undefined' && navigator.language.toLowerCase().startsWith('en')
      ? 'en'
      : 'de'
  } catch {
    return 'de'
  }
}
